import React, { useEffect, useState } from "react"
import { Routes, useLocation } from "react-router-dom"
import TopBarProgress from "react-topbar-progress-indicator"

const CustomSwitch = ({ children }) => {
    const [progress, setProgress] = useState(false)
    const [prevLoc, setPrevLoc] = useState("")
    const location = useLocation()

    useEffect(() => {
        setPrevLoc(location.pathname)
        setProgress(true)
        if (location.pathname === prevLoc) {
            setPrevLoc('')
        }
        // eslint-disable-next-line
    }, [location])

    useEffect(() => {
        setProgress(false)
        // eslint-disable-next-line
    }, [prevLoc])

    return (
        <>
            {progress && <TopBarProgress />}
            <Routes>{children}</Routes>
        </>
    )
}

export default CustomSwitch